module.exports = " <div class=notification transition=notification> {{ notification.title }} </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Notification.vue
// module id = 145
// module chunks = 0